import AppShell from "@/pages/AppShell";
import { LayoutDashboard, BookOpen, Trophy, User, Headphones } from "lucide-react";

const NAV = [
  { to: "/student", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/student/tests", label: "My Tests", icon: BookOpen },
  { to: "/student/podcasts", label: "Podcasts", icon: Headphones },
  { to: "/student/rewards", label: "Rewards", icon: Trophy },
  { to: "/student/profile", label: "Profile", icon: User },
];

export default function StudentLayout() {
  return <AppShell nav={NAV} brandLabel="Mock Test Club" accent="Student" />;
}
